import PropTypes from 'prop-types';
import React from 'react';

import { locale } from 'utils/locale';

import DeepDive from 'components/DeepDive/DeepDive';
import localize from 'components/Localize/Localize';
import SingleBlock from 'components/DeepDive/SingleBlock/SingleBlock';
import SplitImage from 'components/SplitImage/SplitImage';

import styles from './CoolByDesign.css';
import translations from './translations';

class CoolByDesign extends React.Component {
  render() {
    const callout = locale(this.props.locale).isEnglish() ? this.props.t.content.callout : null;

    return (
      <section className={styles[`container`]}>
        <SplitImage
          callout={callout}
          content={this.props.t.content}
          imageConfig={this.props.imageConfig}
          imagePosition="left"
        />
        <DeepDive
          englishPromptText={translations[`en-US`].deepDive.promptText}
          t={this.props.t.deepDive}
        >
          <SingleBlock block={this.props.t.deepDive.blocks[0]} />
        </DeepDive>
      </section>
    );
  }
}

CoolByDesign.propTypes = {
  imageConfig: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  t: PropTypes.shape({
    deepDive: PropTypes.object.isRequired,
    content: PropTypes.shape({
      body: PropTypes.string.isRequired,
      callout: PropTypes.string.isRequired,
      heading: PropTypes.string.isRequired,
      imageDescription: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default localize(CoolByDesign, translations);
